<template>
  <NConfigProvider class="app-content" :theme="darkTheme" :locale="zhCN" :date-locale="dateZhCN" :theme-overrides="themeOverrides">
    <NGlobalStyle></NGlobalStyle>
    <router-view />
  </NConfigProvider>
</template>

<script setup lang="ts">
import { darkTheme, dateZhCN, NConfigProvider, zhCN, NGlobalStyle } from "naive-ui";
import { ref, provide, onMounted, onUnmounted } from "vue";

const themeOverrides = ref({
  common: {
    primaryColor: '#F59E0B',    // 黄色
    primaryColorHover: '#FBBF24',
    primaryColorPressed: '#D97706',
    primaryColorSuppl: '#F59E0B',
  }
});

// 统一调试模式：Ctrl+Shift+D 一键切换所有快捷显示（收益统计/高级设置/线路地址/卡牌真实模式）
const debugMode = ref(false);
provide('debugMode', debugMode);

function handleKeydown(e: KeyboardEvent) {
  if (e.ctrlKey && e.shiftKey && e.key === 'D') {
    e.preventDefault();
    debugMode.value = !debugMode.value;
    localStorage.setItem('kp_debugMode', debugMode.value ? '1' : '0');
  }
}

onMounted(() => {
  debugMode.value = localStorage.getItem('kp_debugMode') === '1';
  window.addEventListener('keydown', handleKeydown);
});
onUnmounted(() => window.removeEventListener('keydown', handleKeydown));
</script>
<style lang="scss">
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#app {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .app-content {
    width: 100%;
    height: 100%;
  }
}
</style>
